import { useContext } from "react";

import { isFeatureEnabled } from "../configs/featureFlags";
import AuthContext from "../store/auth-context";

/**
 * Runtime kill switch for HTML Based Issuance (REACT_APP_ENABLE_HTML_DESIGNS).
 * Independent of the per-tenant API flag: when this is off the designer is hidden.
 */
export const isHtmlDesignsBuildEnabled = () =>
  isFeatureEnabled("HTML_DESIGNS", false);

/**
 * Whether this viewer may use the certificate designer.
 *
 * Two gates, both of which must pass:
 *  - REACT_APP_ENABLE_HTML_DESIGNS (runtime / env), and
 *  - `is_html_designs_enabled` from GET /api/users/me/permissions, which is
 *    per tenant.
 *
 * A signed-out visitor has no permissions yet, so only the env flag applies
 * — they see the entry point and are asked to sign in, exactly as before.
 */
export default function useHtmlDesignsEnabled() {
  const { isLoggedIn, isHtmlDesignsEnabled } = useContext(AuthContext);
  if (!isHtmlDesignsBuildEnabled()) return false;
  return !isLoggedIn || isHtmlDesignsEnabled === true;
}
